import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

import EditableSection from '../../components/EditableSection';

import DoorsEditor from '../DoorsEditor';
import HolesEditor from '../HolesEditor';
import WindowsEditor from '../WindowsEditor';
import { EditorsWrapper } from './ConstructionExtras.styles';
import PlexiWindowsEditor from '../PlexiWindowsEditor';
import ShutterWindowsEditor from '../ShutterWindowsEditor';
import Roofing from '../Roofing';
import {useTranslation} from "../../contexts/TranslationContext";
import {AppstoreOutlined} from "@ant-design/icons";

const ConstructionExtras = ({
  collapsed,
  translationsData = useTranslation()
}) => (

  <EditableSection
    collapsed={collapsed}
    icon={<AppstoreOutlined />}
    title={translationsData.construction_additives || 'construction_additives'}
  >
    <EditorsWrapper>
      <DoorsEditor collapsed={collapsed} />
      <HolesEditor collapsed={collapsed} />
      <ShutterWindowsEditor collapsed={collapsed} />
      <WindowsEditor collapsed={collapsed} />
      <PlexiWindowsEditor collapsed={collapsed} />
      <Roofing collapsed={collapsed} />
    </EditorsWrapper>
  </EditableSection>
);

ConstructionExtras.propTypes = {
  collapsed: PropTypes.bool.isRequired
};

export default ConstructionExtras;
